import React from 'react';
import { useLocation } from 'react-router-dom';
import { NotificationActionType } from "./NotificationActionTypes";
import ApproveAmendmentAction from "./ApproveAmendmentAction";
import ApproveInvoiceAction from "./ApproveInvoiceAction";
import NotificationActionLayout, { NotificationActionLayoutType } from "../../components/NotificationActionLayout/NotificationActionLayout";
import { notificationSomethingWentWrongContent } from "./NotificationAction.utils";
const NotificationActionPage = () => {
  const {
    state
  } = useLocation();
  if (!state) {
    return /*#__PURE__*/React.createElement(NotificationActionLayout, {
      state: {
        type: NotificationActionLayoutType.AfterAction,
        afterAction: notificationSomethingWentWrongContent
      }
    });
  }
  function renderActionComponent(state) {
    switch (state.type) {
      case NotificationActionType.ApproveAmendment:
        return /*#__PURE__*/React.createElement(ApproveAmendmentAction, {
          token: state.token,
          vendorName: state.vendorName
        });
      case NotificationActionType.ApproveInvoice:
        return /*#__PURE__*/React.createElement(ApproveInvoiceAction, {
          vendorName: state.vendorName,
          token: state.token,
          invoiceFormattedNumber: state.invoiceFormattedNumber,
          invoiceFormattedAmount: state.invoiceFormattedAmount
        });
    }
  }
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "notification-action-page"
  }, renderActionComponent(state));
};
export default NotificationActionPage;